<template>
  <div class="container">
    <section class="article-search">
      <div class="search-wapper">
        <h3>
          <span class="search-title-divider" aria-hidden="true"></span>
          <span class="search-title-text">技术领域分析</span>
          <span class="search-title-divider" aria-hidden="true"></span>
        </h3>
        <div class="searchLeft flex">
          <div class="inputDiv flex">
            <el-input v-model="keyWords" maxlength="100" clearable @keyup.enter.native="toSearch" placeholder="请输入需要检索的内容"></el-input>
            <img src="../../assets/images/search.png" @click="toSearch" />
          </div>
        </div>
      </div>
    </section>
    <div class="w1200">
      <!-- 技术概念 -->
      <div class="page-top" v-loading="loading">
        <h3>技术概念</h3>
        <div class="page1-main">
          <el-tabs v-model="editableTabsValue" @tab-click="handleClickTab" ref="tabs">
            <el-tab-pane v-for="(item, index) in conceptList" :key="index" :label="item.name" :name="item.name" lazy>
              <p class="page1-load" v-if="descLoading">技术概念解析<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
              <div v-if="conceptVal && !descLoading" class="content">
                <typewriter :text="conceptVal" :speed="15"></typewriter>
              </div>
            </el-tab-pane>
          </el-tabs>
          <p class="tips" v-if="conceptList.length > 0"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
        </div>
      </div>
    </div>
    <div class="wapper w1200">
      <div class="tab-main">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="论文" name="1"></el-tab-pane>
          <el-tab-pane label="作者" name="2"></el-tab-pane>
          <el-tab-pane label="机构" name="3"></el-tab-pane>
          <el-tab-pane label="期刊" name="4"></el-tab-pane>
        </el-tabs>
      </div>
      <template v-if="conceptId">
        <div class="tab-content page1" v-if="activeName == '1'">
          <article-list :parentData="search_keywords" :parentConceptId="conceptId" ref="childRef"></article-list>
        </div>
        <div class="tab-content page2" v-if="activeName == '2'">
          <author-list :parentData="search_keywords" :parentConceptId="conceptId" ref="childRef"></author-list>
        </div>
        <div class="tab-content page3" v-if="activeName == '3'">
          <institution-list :parentData="search_keywords" :parentConceptId="conceptId" ref="childRef"></institution-list>
        </div>
        <div class="tab-content page4" v-if="activeName == '4'">
          <journal-list :parentData="search_keywords" :parentConceptId="conceptId" ref="childRef"></journal-list>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ArticleList from "./article";
import AuthorList from "./author";
import InstitutionList from "./institution";
import JournalList from "./journal";
import typewriter from "@/components/typewriter.vue";
export default {
  data() {
    return {
      loading: false,
      activeName: "1",
      keyWords: "",
      search_keywords: "",

      conceptList: [], //技术概念tab
      editableTabsValue: "", //选中的值
      conceptVal: "",
      conceptId: "",

      hotWords: "",
      topYears: "",
    };
  },
  components: {
    ArticleList,
    AuthorList,
    InstitutionList,
    JournalList,
    typewriter,
  },

  mounted() {
    this.keyWords = sessionStorage.getItem("trend_word");
    this.search_keywords = this.keyWords;
    this.activeName = this.$route.query.type;

    this.getConceptList();
  },
  methods: {
    // tab列表
    getConceptList() {
      this.$http({
        url: "api/v1/concept/list?keywords=" + this.search_keywords,
        method: "get",
      }).then(res => {
        this.loading = false;
        this.$nextTick(() => {
          this.conceptList = res.data;
          if (this.conceptList.length > 0) {
            setTimeout(() => {
              this.isRightArrow();
            }, 300);
            if (this.$route.query.value) {
              this.editableTabsValue = this.$route.query.value;
              this.conceptId = this.$route.query.conceptId;
            } else {
              this.editableTabsValue = this.conceptList[0].name;
              this.conceptId = this.conceptList[0].conceptId;
            }
            this.descLoading = true;
            setTimeout(() => {
              this.getDescription();
            }, 1200);
          }
        });
      });
    },
    // 获取描述
    getDescription() {
      this.$http({
        url: "api/v1/concept/message?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.descLoading = false;
        this.conceptVal = res.data;
      });
    },
    // 动态显示隐藏左右箭头
    isRightArrow() {
      this.$nextTick(() => {
        // 找出下面对应的nav实例
        function findTabNavVue(vueStance) {
          const childrens = vueStance.$children;
          const len = childrens.length;
          for (let i = 0; i < len; i++) {
            const child = childrens[i];
            if (child.scrollNext) return child;
          }
        }
        const navVue = findTabNavVue(this.$refs.tabs);
        if (navVue.$el.querySelector(".el-tabs__nav-prev")) {
          navVue.$el.querySelector(".el-tabs__nav-prev").style.visibility = "hidden";
        }
        if (navVue.scrollable) {
          let nextNode;
          let nextNode2;
          navVue.$watch("navOffset", function (currentOffset) {
            var navSize = this.$refs.nav["offsetWidth"];
            var containerSize = this.$refs.navScroll["offsetWidth"];
            const isRight = navSize - currentOffset <= containerSize;
            const isLeft = currentOffset == 0;
            nextNode = nextNode ? nextNode : navVue.$el.querySelector(".el-tabs__nav-next");
            nextNode.style.visibility = isRight ? "hidden" : "";

            nextNode2 = nextNode2 ? nextNode2 : navVue.$el.querySelector(".el-tabs__nav-prev");
            nextNode2.style.visibility = isLeft ? "hidden" : "";
          });
        }
      });
    },
    toSearch() {
      if (!this.keyWords) {
        if (sessionStorage.getItem("trend_word")) {
          this.keyWords = sessionStorage.getItem("trend_word");
        } else {
          this.$message.error("请输入需要检索的内容");
          return;
        }
      }
      this.search_keywords = this.keyWords;
      sessionStorage.setItem("trend_word", this.keyWords);
      this.$router.push({
        path: "/trend",
      });
    },
    handleClickTab(tab) {
      this.descLoading = true;
      this.editableTabsValue = this.conceptList[tab.index].name;
      this.conceptId = this.conceptList[tab.index].conceptId;
      setTimeout(() => {
        this.getDescription();
      }, 1200);
      this.$nextTick(() => {
        this.$refs.childRef.clearSearch();
      });
      if (this.$route.query.years) {
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 先拷贝一个一模一样的对象
        delete newQuery.years; //再删除page
        this.$router.replace({ query: newQuery });
      }
      if (this.$route.query.words) {
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 先拷贝一个一模一样的对象
        delete newQuery.words; //再删除page
        this.$router.replace({ query: newQuery });
      }
    },

    handleClick(val) {},
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 154px);
  .article-search {
    width: 100%;
    padding-top: 40px;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    .search-wapper {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }
    h3 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      .search-title-divider {
        flex: 0 0 26px;
        height: 1px;
        background-color: #cccccc;
      }
      .search-title-text {
        min-width: 0;
        overflow-wrap: anywhere;
      }
    }
    .searchLeft {
      border: 1px solid #cccccc;
      width: 640px;
      height: 52px;
      background: #fff;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      ::v-deep .el-input__inner {
        border: none;
        height: 52px;
        background: none;
        border-radius: 0;
      }

      .inputDiv {
        align-items: center;
        flex: 1;
        background: #fff;
        ::v-deep .el-input {
          flex: 1;
        }
      }
      img {
        width: 22px;
        height: 24px;
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }
  .page-top {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(39, 42, 46, 0.1);
    h3 {
      height: 62px;
      margin: -20px -20px 0;
      padding: 0 20px;
      color: #202224;
      font-size: 18px;
      line-height: 62px;
      background: url("../../assets/images/trend_h3.png") no-repeat 0;
      background-size: 240px 100%;
    }
    .page1-main {
      min-height: 100px;
      .tabs-wrap {
        position: relative;
        display: flex;
        flex: auto;
        overflow: hidden;
        white-space: nowrap;
        transform: translate(0);
      }
    }
    ::v-deep .el-tabs__item {
      color: #636870;
      cursor: pointer;
      position: relative;
      font-size: 16px;
    }
    ::v-deep .is-active {
      color: #2d8cf0;
      font-size: 20px;
      font-weight: bold;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
    }
    ::v-deep .el-tabs__nav-wrap {
      padding: 0 25px;
      > span {
        font-size: 20px;
        line-height: 39px;
      }
    }
    ::v-deep .content {
      color: #636870;
      padding: 20px 0;
      font-size: 14px;
      line-height: 22px;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    .rotating-image {
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .page1-load {
      font-size: 14px;
      color: #636870;
      padding: 20px 0;
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
      }
    }
    .tips {
      color: #969ca4;
      font-size: 12px;
      text-align: right;
      i {
        margin-right: 5px;
      }
    }
  }
  .wapper {
    background: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
  }
  .tab-main {
    height: 62px;
    color: #202224;
    font-size: 18px;
    line-height: 62px;
    background: url("../../assets/images/trend_h3.png") no-repeat 0;
    background-size: 240px 100%;
    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
    }
    ::v-deep .el-tabs__nav-wrap {
      padding: 0 20px;
    }
    ::v-deep .el-tabs__item {
      font-size: 16px;
      color: #86909c;
    }
    ::v-deep .is-active {
      color: #202224;
      font-weight: bold;
    }
    ::v-deep .el-tabs {
      background: #fff;
    }
  }
  .tab-content {
    padding: 20px;
  }
}
</style>
